import React, { useState, useEffect } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import Utils from "../../../Common/Utils";
import AppSettings from "../../../Settings/AppSettings";
import Paginator from "../../Common/Paginator";
import DatePicker from "react-datepicker";
import CustomDatePicker from "../../Common/CustomDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import AuthManager from "../../../Common/AuthManager";

function Logs() {
  var stDate = new Date();
  stDate.setDate(stDate.getDate() - 6);
  var edDate = new Date();
  var [loadError, setLoadError] = React.useState(false);
  var [logsList, setLogsList] = React.useState([]);
  var [logsListCopy, setLogsListCopy] = React.useState([]);
  var [loading, setLoading] = React.useState(false);
  //var [currentPage, setCurrentPage] = useState(1);
  var [recordPerPage, setRecordPerPage] = useState(5);
  var [searchval, setSearchVal] = useState("");
  var [pageRangeArray, setPageRangeArray] = useState([5, 10, 15, 25, 50, 100]);
  var [startDate, setStartDate] = useState(stDate);
  var [endDate, setEndDate] = useState(edDate);
  const startDateref = React.createRef();
  const endDateref = React.createRef();

  // total records per page to display
  // const recordPerPage = 2;
  // range of pages in paginator
  const pageRange = 10;
  // const logsListCopyRef = React.useRef(logsListCopy);
  // logsListCopyRef.current = logsListCopy;

  const searchValRef = React.useRef(searchval);
  searchValRef.current = searchval;

  // const recordPerPageRef = React.useRef(recordPerPage);
  // recordPerPageRef.current = recordPerPage;

  function getDate_as_string(dt) {
    return (
      dt.getFullYear() +
      "-" +
      Utils.appendLeadingZeroes(dt.getMonth() + 1) +
      "-" +
      Utils.appendLeadingZeroes(dt.getDate())
    );
  }

  function get_just_date_from_datestring(dt) {
    var sarr = dt.split(":");
    if (sarr.length < 3) return dt;
    if (sarr[2].includes(".")) {
      var rr = sarr[2].split(".");
      return sarr[0] + ":" + sarr[1] + ":" + rr[0];
    }
    return sarr[0] + ":" + sarr[1] + ":" + sarr[2];
  }

  async function loadLogList() {
    setLoading(true);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doPost(
      api_base_url + "user/logs/list",
      {
        startdate: getDate_as_string(startDate),
        enddate: getDate_as_string(endDate),
      },
      null,
      AuthManager.getGmsToken()
    );
    setLoadError(ret.errorfound);
    if (!ret.errorfound) {
      setLogsList(ret.data.data);
      let tempVar = JSON.parse(JSON.stringify(ret.data.data));
      setLogsListCopy(tempVar);
    }
    setLoading(false);
  }

  async function handle_page_change(pagenumber, paged_data) {
    if (paged_data !== undefined) {
      var tt = paged_data;
      setLogsList(tt);
    }
    await Utils.sleep(100);
  }

  async function handle_log_search(val) {
    if (logsList.length === 0) setLogsList((t) => (t = get_filtered_records()));

    val = val.toString().trim().toLowerCase();
    setSearchVal((n) => (n = val));
    await Utils.sleep(100);
    // handle_page_change(currentPage);
  }

  function handle_recordsperpage_change(newval) {
    setRecordPerPage(parseInt(newval));
  }

  function get_filtered_records() {
    let filteredData = JSON.parse(JSON.stringify(logsListCopy));
    if (!Utils.isEmpty(searchval)) {
      filteredData = logsListCopy.filter((item) => {
        if (
          (item.username != null &&
            item.username.toLowerCase().includes(searchValRef.current)) ||
          (item.module != null &&
            item.module.toLowerCase().includes(searchValRef.current)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchValRef.current)) ||
          (item.nodeId != null &&
            item.nodeId.toLowerCase().includes(searchValRef.current)) ||
          (item.fromSource != null &&
            item.fromSource.toLowerCase().includes(searchValRef.current)) ||
          (item.createdAt != null &&
            item.createdAt.toLowerCase().includes(searchValRef.current))
        ) {
          return true;
        } else {
          return false;
        }
      });
    }
    return filteredData;
  }

  useEffect(() => {
    loadLogList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {loading && (
        <div>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>Loading Logs</strong>
          </div>
        </div>
      )}
      {!loading && (
        <React.Fragment>
          <div className="d-flex flex-nowrap">
            <div className="">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="yyyy-MM-dd"
                customInput={<CustomDatePicker ref={startDateref} />}
              />
            </div>
            <div className="">
              &nbsp;
              <DatePicker
                className="col-auto"
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="yyyy-MM-dd"
                customInput={<CustomDatePicker ref={endDateref} />}
              />
            </div>
            <div className="">
              &nbsp;
              <button
                className="col-auto"
                type="button"
                onClick={() => loadLogList()}
              >
                <span className="fa fa-search"></span>&nbsp; Search
              </button>
            </div>
          </div>

          <div className="row">&nbsp;</div>
          {logsListCopy.length > 0 && !loadError && (
            <React.Fragment>
              <div>
                <h1 className="h6 float-start">
                  Logs from <i>{getDate_as_string(startDate)}</i> to{" "}
                  <i>{getDate_as_string(endDate)}</i>
                </h1>

                <select
                  id="inputState"
                  className="border  form-control-sm col-1 border-secondary float-end"
                  value={recordPerPage}
                  onChange={(e) => {
                    handle_recordsperpage_change(e.target.value);
                  }}
                >
                  {pageRangeArray.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </React.Fragment>
          )}
          {logsListCopy.length > 0 && !loadError && (
            <div>
              <input
                type="text"
                className="border form-control form-control-sm border-secondary float-end"
                placeholder="Search logs"
                onChange={(e) => handle_log_search(e.target.value)}
              />
            </div>
          )}
          <div className="table-responsive">
            {logsList.length > 0 && !loadError && (
              <React.Fragment>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th width="10%">User</th>
                      <th width="65%">Module / Description</th>
                      <th width="10%">From</th>
                      <th width="8%">On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logsList.map((item, index) => (
                      <tr key={"logs" + index}>
                        <td>{item.username}</td>
                        <td>
                          <span className="badge bg-primary">
                            {item.module}
                          </span>
                          {item.nodeId !== "" && (
                            <>
                              &nbsp;
                              <span className="badge rounded-pill bg-warning text-dark">
                                Node ID: {item.nodeId}
                              </span>
                            </>
                          )}
                          <br />
                          {item.status.toLowerCase() === "success" && (
                            <span
                              className="fa fa-check-circle"
                              style={{ color: "green" }}
                            />
                          )}
                          {item.status.toLowerCase() !== "success" && (
                            <span
                              className="fa fa-exclamation-triangle"
                              style={{ color: "red" }}
                            />
                          )}
                          &nbsp;
                          {item.description}
                        </td>
                        <td>
                          <span className="badge bg-secondary">
                            {item.fromSource}
                          </span>
                        </td>
                        <td>
                          {item.createdAt.split("T")[0]}
                          <br />
                          <small className="text-muted">
                            <strong>
                              {get_just_date_from_datestring(
                                item.createdAt.split("T")[1]
                              )}
                            </strong>
                          </small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="float-end">
                  <Paginator
                    recordPerPage={recordPerPage}
                    totalRecords={get_filtered_records().length}
                    data={get_filtered_records()}
                    pageRange={pageRange}
                    onPageChange={handle_page_change}
                  />
                </div>
              </React.Fragment>
            )}

            {logsList.length === 0 && logsListCopy.length > 0 && !loadError && (
              <div className="p-2 bg-white alert alert-danger" role="alert">
                <strong>Sorry!</strong>, No records found during our search
              </div>
            )}

            {logsListCopy.length === 0 && !loadError && (
              <div className="p-2 bg-white alert alert-danger" role="alert">
                <strong>Sorry!</strong>, No records found for the selected date
                range
              </div>
            )}
            {loadError && (
              <div className="p-2 bg-white alert alert-danger" role="alert">
                <strong>Oops</strong>, An error occurred
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default Logs;
